import { Guid } from "guid-typescript";
import _ from "lodash";
import * as React from "react";
import { PropertyHelper } from "../../../../shared/utility/property-helper";
import KuikaInput from "../../../ui-kit/kuika-input/kuika-input";

export interface IPropertyFormInputPropertyState {
  value: string;
  currentValue: string;
}

export interface IPropertyFormInputPropertyProps {
  key?: string;
  value: string;
  onChange: (value: string) => void;
  changeType: "onBlur" | "onKeyPress";
  updateDebounce: number;
  shouldFocus?: boolean;
  disabled?: boolean;
  testId?: string;
}

export class PropertyFormInputProperty extends React.PureComponent<
  IPropertyFormInputPropertyProps,
  IPropertyFormInputPropertyState & { displayValue: string }
> {
  private uniquePropertyInputId: Guid = Guid.create();

  private isFocused: boolean = false;

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      currentValue: "",
      displayValue: PropertyHelper.getTextValueForDisplay(this.props.value)
    };
  }

  public static defaultProps = {
    changeType: "onKeyPress"
  };

  componentDidMount(): void {
    this.setState({ currentValue: this.props.value });
    document.addEventListener("click", this.onClickOutside.bind(this));
  }

  componentDidUpdate = (prevProps: IPropertyFormInputPropertyProps) => {
    if (prevProps === this.props) return;
    if (this.isFocused) return;
    this.setState({
      value: PropertyHelper.getTextValueForMetaData(this.props.value, this.props.shouldFocus),
      displayValue: PropertyHelper.getTextValueForDisplay(this.props.value)
    });
  };

  componentWillUnmount(): void {
    document.removeEventListener("click", this.onClickOutside.bind(this));
  }

  waitAndChange = _.debounce((value: string) => this.props.onChange(value), this.props.updateDebounce);

  clearInput = () => {
    this.props.onChange("");
  };

  handleChangeValue = (event: any) => {
    this.setState({ displayValue: event.target.value });

    if (this.props.changeType === "onKeyPress") {
      const value = PropertyHelper.getTextValueForMetaData(event.target.value, this.props.shouldFocus);
      this.waitAndChange(value);
    }

    if (this.props.changeType === "onBlur") {
      const value = PropertyHelper.getTextValueForMetaData(event.target.value, this.props.shouldFocus);
      this.setState({ currentValue: value });
    }
  };

  handleBlur = (event: any) => {
    if (this.props.changeType === "onBlur") {
      const value = PropertyHelper.getTextValueForMetaData(event.target.value, this.props.shouldFocus);
      if (value !== this.props.value) {
        this.props.onChange(value);
      }
      this.isFocused = false;
    }
  };

  handleFocus = (event: any) => {
    event.target.select();
    this.isFocused = true;
  };

  onFocusCapture = () => {
    this.isFocused = true;
  };

  onClickOutside = (e: MouseEvent) => {
    const currentInputId = `property-input-${this.uniquePropertyInputId.toString()}`;
    if (!(e.target instanceof HTMLElement)) return;
    if (e.target.id === currentInputId) return;

    if (this.isFocused) {
      this.handleBlur({
        target: {
          value: this.state.currentValue
        }
      });
    }
  };

  render() {
    return (
      <>
        <div className="kuika_property-grid-column kuika-right-panel__col">
          <KuikaInput
            type="textarea"
            size="sm"
            rows={2}
            id={`property-input-${this.uniquePropertyInputId.toString()}`}
            data-testid={this.props.testId}
            style={{ width: "100%", height: "auto" }}
            className="kuika_multiline_property kuika_property-grid-input"
            value={this.state.displayValue}
            allowClear
            onChange={this.handleChangeValue}
            onBlur={this.handleBlur}
            // autoFocus
            onFocusCapture={this.onFocusCapture}
            onFocus={this.handleFocus}
            disabled={this.props.disabled}
          />
        </div>
      </>
    );
  }
}
